// extracted by mini-css-extract-plugin
module.exports = {"Location":"Lbl5-IO3","locationPin":"Lq-R0HJZ"};